/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyIsNullLabelKey: core.serialization.ObjectSchema<
    serializers.KeyIsNullLabelKey.Raw,
    Truvity.KeyIsNullLabelKey
> = core.serialization.object({
    key: core.serialization.string(),
});

export declare namespace KeyIsNullLabelKey {
    export interface Raw {
        key: string;
    }
}
